import { useState, useRef, useEffect } from 'react';
import IApopup from './IApopup';

function AnimatedCircle() {
    const [isHovered, setIsHovered] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const circleRef = useRef(null);

    const [translate, setTranslate] = useState({ x: 28, y: window.innerHeight - 96 });

    const handleClick = () => {
        if (!isExpanded && circleRef.current) {
            const mainContent = document.getElementById('main-content');
            if (mainContent) {
                const rect = mainContent.getBoundingClientRect();
                const centerX = rect.left + rect.width / 2;
                const centerY = rect.top + rect.height / 2;
                setTranslate({ x: centerX, y: centerY });
            }
        } else {
            setTranslate({ x: 28, y: window.innerHeight - 96 });
        }

        setIsExpanded(prev => !prev);
    };

    useEffect(() => {
        const handleResize = () => {
            if (isExpanded) {
                const mainContent = document.getElementById('main-content');
                if (mainContent) {
                    const rect = mainContent.getBoundingClientRect();
                    const centerX = rect.left + rect.width / 2;
                    const centerY = rect.top + rect.height / 2;
                    setTranslate({ x: centerX, y: centerY });
                }
            } else {
                setTranslate({
                    x: 28,
                    y: window.innerHeight - 96,
                });
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isExpanded]);

    return (
        <>
            {isExpanded && (
                <div
                    className="z-40 fixed inset-0 transition-opacity duration-700 ease-in-out"
                    onClick={handleClick}
                />
            )}

            <div className={`relative ${isExpanded ? 'z-50' : 'z-0'}`}>
                <div
                    ref={circleRef}
                    onClick={handleClick}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    className={`
                        fixed top-0 left-0 transition-all duration-700 ease-in-out overflow-hidden
                        ${isExpanded ? 'w-1/2 h-2/3 p-2' : 'w-8 h-8 cursor-pointer'}
                        ${isHovered || isExpanded
                            ? 'shadow-[0_0_15px_5px_rgba(249,142,41,0.8)]'
                            : 'shadow-[0_0_10px_2px_rgba(249,142,41,0.6)]'}
                    `}
                    style={{
                        transform: `translate(${translate.x}px, ${translate.y}px) translate(-50%, -50%)`,
                        borderRadius: isExpanded ? '20px' : '9999px',
                        background: 'linear-gradient(270deg, #F96F29, #F9B429, #F98429, #F96F29, #F9B429)',
                        backgroundSize: '600% 600%',
                        animation: 'gradientWave 8s ease infinite',
                    }}
                >
                    <div className="absolute inset-0 flex justify-center items-center font-bold text-white">
                        {isExpanded ? (
                            <IApopup />
                        ) : (
                            <span className="text-xs">IA</span>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default AnimatedCircle;
